import { ERROR_STATUS, PAGE_CONTEXT } from '../constants';
import type { ErrorCodeType } from '../types/lead.types';

export const generatePopupId = (
    page: (typeof PAGE_CONTEXT)[keyof typeof PAGE_CONTEXT],
    errorCode: ErrorCodeType | null,
) => {
    const gape = page || 'unknown_page';
    const errorText = errorCode ? ERROR_STATUS[errorCode] : ERROR_STATUS.UNKNOWN_ERROR;
    return `${gape}_${errorText}`;
};
